// extracted by mini-css-extract-plugin
module.exports = {"singpass":"Login_singpass__sAwDi"};